import React from 'react';

function NotFound() {
    return (
        <>
        <h4>Sorry! page not found</h4>
        </>
    );
}

export default NotFound;